
import React from 'react'
import Useaxios from 'utils/Useaxios'

const layerServices = () => {
    const { fetchData } = Useaxios()

    const createLayer = async (paylad) => {
        try {
            const res = await fetchData({
                url: `/api/machines/layers`,
                method: "POST",
                data: paylad
            })
            console.log(res)
            return res
        } catch (error) {
            console.log(error)
        }
    }

    const getMachineLayer = async (machineId) => {
        try {
            const res = await fetchData({
                url: `/api/machines/layers/${machineId}`,
            })
            console.log(res)
            return res
        } catch (error) {
            console.log(error)
        }
    }

    const assignProducts = async (params, payload) => {
        try {
            const res = await fetchData({
                url: `/api/machines/layers/${params?.machineId}/${params.layerId}`,
                method: "POST",

                data: { slotsData: payload }
            })
            console.log(res)
        } catch (error) {
            console.log(error)
        }
    }

    const uploadImage = async (imageData) => {
        try {
            const res = await fetchData({
                url: `/api/products/uploadImage`,
                method: "POST",
                data: imageData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            console.log(res)
            return res
        } catch (error) {
            console.log(error)
        }
    }

    const createProduct = async (payload) => {
        try {
            const res = await fetchData({
                url: '/api/products/createProduct',
                method: "POST",
                data: payload
            })
            return res
        } catch (error) {
            console.log(error)
        }
    }

    const getLayerService = async (params) => {
        try {
            const res = await fetchData({
                url: `/api/machines/layers/${params?.machineId}/${params.layerId}`,
                method: "GET"
            })
            return res
        } catch (error) {
            console.log(error)
        }
    }
    return { createLayer, getMachineLayer, uploadImage, createProduct, assignProducts ,getLayerService }
}

export default layerServices
